import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=4d5aa038&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5aa038')) {
      api.createRecord('4d5aa038', component.options)
    } else {
      api.reload('4d5aa038', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=4d5aa038&", function () {
      api.rerender('4d5aa038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Category.vue"
export default component.exports